import { render, staticRenderFns } from "./AgeWiseInsight.vue?vue&type=template&id=1971fe56&"
import script from "./AgeWiseInsight.vue?vue&type=script&lang=js&"
export * from "./AgeWiseInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports